export const recomputeViewport = () => {
  if (typeof window !== 'undefined') {
    const width = document.documentElement.clientWidth / 100;

    const height = window.innerHeight / 100;

    document.body.style.setProperty('--computed-vh', `${height}px`);
    document.body.style.setProperty('--computed-vw', `${width}px`);
  }
};
